import * as React from 'react';
import { createElement } from 'react';
import ReactRenderer from '@alilc/lowcode-react-renderer';
import { injectComponents } from '@alilc/lowcode-plugin-inject';
import { buildComponents, AssetLoader } from '@alilc/lowcode-utils';
import { Nav, Loading } from "@alifd/next";
import { siteMenuGetBySiteMenuDetail, siteMenuListSiteMenu, releaseSiteMenuTree, releaseSiteMenuDetail } from '../../http/api';
import { getUrlParams } from '../../utils/common';
import './index.scss';
const { SubNav, Item } = Nav;
export default class MenuList extends React.PureComponent {
    state;
    setState;
    props;
    constructor(props) {
        super(props);
        this.state = {
            mode: 'inline',
            directionMenu: 'ver',
            menuData: [],
            openKey: [],
            selectedKeys: '',
            schema: null,
            components: null,
            type: 'primary',
            header: '',
            isShow: true,
            loading: false,
            currDom: ''
        };
    }
    componentDidMount() {
        if (!getUrlParams("releaseId")) {
            this.siteMenuListSiteMenuData();
        }
        else {
            this.releaseSiteMenuTreeData();
        }
        this.setState({
            mode: this.props.mode,
            directionMenu: this.props.directionMenu,
            type: this.props.type,
            header: this.props.header,
            currDom: this.props.__designMode === 'design' && parent.AliLowCodeEngine ? parent.AliLowCodeEngine.project.currentDocument : null
        });
    }
    getData = (val) => {
        this.setState({
            selectedKeys: `${val.siteMenuId}`,
            schema: null,
            components: null,
        });
        if (!getUrlParams("releaseId")) {
            this.siteMenuGetBySiteMenuDetailData(val);
            if (this.props.__designMode === 'design') {
                const getNode = this.state.currDom.getNodeById(this.props.componentId);
                getNode.setPropValue('siteMenuId', val.siteMenuId);
            }
        }
        else {
            this.releaseSiteMenuDetailData(val);
        }
    };
    init = async (getPageSchemaData) => {
        const { componentsMap: componentsMapArray, componentsTree } = getPageSchemaData.schema;
        const componentsMap = {};
        componentsMapArray.forEach((component) => {
            componentsMap[component.componentName] = component;
        });
        const schema = componentsTree[0];
        const libraryMap = {};
        const libraryAsset = [];
        getPageSchemaData.packages.forEach(({ package: _package, library, urls, renderUrls }) => {
            libraryMap[_package] = library;
            if (renderUrls) {
                libraryAsset.push(renderUrls);
            }
            else if (urls) {
                libraryAsset.push(urls);
            }
        });
        const assetLoader = new AssetLoader();
        await assetLoader.load(libraryAsset);
        const components = await injectComponents(buildComponents(libraryMap, componentsMap));
        this.setState({
            isShow: true,
            schema,
            components
        });
    };
    siteMenuGetBySiteMenuDetailData = (item) => {
        this.setState({
            loading: true
        });
        siteMenuGetBySiteMenuDetail({ siteMenuId: item.siteMenuId }).then(({ data, resultCode }) => {
            if (resultCode === 200 && data.siteMenuJson) {
                const json = JSON.parse(data.siteMenuJson);
                this.init(json);
            }
            else {
                this.setState({
                    isShow: false
                });
            }
            this.setState({
                loading: false
            });
        });
    };
    releaseSiteMenuDetailData = (item) => {
        this.setState({
            loading: true
        });
        releaseSiteMenuDetail({ siteMenuId: item.siteMenuId, releaseId: getUrlParams("releaseId") }).then(({ data, resultCode }) => {
            if (resultCode === 200 && data.siteMenuJson) {
                const json = JSON.parse(data.siteMenuJson);
                this.init(json);
            }
            else {
                this.setState({
                    isShow: false,
                });
            }
            this.setState({
                loading: false
            });
        });
    };
    getChildren = (data, opKey) => {
        opKey.push(`${data.siteMenuId}`);
        if (data.children.length) {
            this.getChildren(data.children[0], opKey);
        }
        else {
            this.setState({
                selectedKeys: `${data.siteMenuId}`
            });
            if (!getUrlParams("releaseId")) {
                this.siteMenuGetBySiteMenuDetailData(data);
                if (this.props.__designMode === 'design') {
                    const getNode = this.state.currDom.getNodeById(this.props.componentId);
                    getNode.setPropValue('siteMenuId', data.siteMenuId);
                }
            }
            else {
                this.releaseSiteMenuDetailData(data);
            }
        }
    };
    siteMenuListSiteMenuData = () => {
        siteMenuListSiteMenu({ siteIds: [getUrlParams("siteId")] }).then(({ data, resultCode }) => {
            if (resultCode === 200) {
                this.setState({
                    menuData: data
                });
                const opKey = [];
                this.getChildren(data[0], opKey);
                this.setState({
                    openKey: opKey
                });
            }
        });
    };
    releaseSiteMenuTreeData = () => {
        releaseSiteMenuTree({ releaseId: getUrlParams("releaseId") }).then(({ data, resultCode }) => {
            if (resultCode === 200) {
                this.setState({
                    menuData: data
                });
                const opKey = [];
                this.getChildren(data[0], opKey);
                this.setState({
                    openKey: opKey
                });
            }
        });
    };
    componentWillReceiveProps(nextProps) {
        if (this.props.mode != nextProps.mode) {
            this.setState({
                mode: nextProps.mode
            });
        }
        if (this.props.directionMenu != nextProps.directionMenu) {
            this.setState({
                directionMenu: nextProps.directionMenu,
            });
        }
        if (this.props.type != nextProps.type) {
            this.setState({
                type: nextProps.type,
            });
        }
        if (this.props.header != nextProps.header) {
            this.setState({
                header: nextProps.header,
            });
        }
        if (this.props.siteMenuName != nextProps.siteMenuName) {
            this.siteMenuListSiteMenuData();
        }
    }
    domData(item) {
        return (item.children.length ?
            createElement(SubNav, { key: item.siteMenuId, label: item.siteMenuName }, item.children.map(val => item.children.length ? this.domData(val) : createElement(Item, { onClick: () => this.getData(val), key: val.siteMenuId }, val.siteMenuName)))
            :
                createElement(Item, { onClick: () => this.getData(item), key: item.siteMenuId }, item.siteMenuName));
    }
    header = () => (createElement("span", { className: "fusion" }, this.state.header));
    footer = () => (createElement("a", { className: "login-in", href: "javascript:;" }, "Login in"));
    render() {
        return (createElement("div", { style: { height: '100%' } }, this.state.openKey.length ?
            createElement("div", { ...this.props, className: this.state.directionMenu === 'ver' ? "verMenu menu" : "menu", style: { ...this.props.style } },
                createElement(Nav, { className: "basic-nav", mode: this.state.mode, direction: this.state.directionMenu, type: this.state.type, openMode: "single", header: this.state.directionMenu === 'ver' ? "" : this.header(), defaultOpenKeys: this.state.directionMenu === 'ver' ? this.state.openKey : [], selectedKeys: this.state.selectedKeys, triggerType: "click", style: { padding: this.state.directionMenu === 'ver' ? '0' : '0 10px' } }, this.state.menuData.map(item => this.domData(item))),
                createElement("div", { className: "content", style: { display: this.state.directionMenu === 'ver' ? 'calc(100% - 200px)' : '100%' } }, !this.state.loading ? createElement("div", { style: { height: '100%' } }, this.state.isShow ? createElement("div", { className: "lowcode-plugin-sample-preview" },
                    createElement(ReactRenderer, { className: "lowcode-plugin-sample-preview-content", schema: this.state.schema, components: this.state.components }))
                    :
                        createElement("div", { style: { width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px' } },
                            createElement("div", null, "\u6682\u65E0\u6570\u636E")))
                    :
                        createElement("div", { style: { height: '100%', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' } },
                            createElement(Loading, { tip: "\u52A0\u8F7D\u4E2D..." },
                                createElement("div", { className: "demo-basic" })))))
            : ''));
    }
}
;
